import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AccountDetails from '../components/Frontend/AccountDetails/AccountDetails';
import { AccountContextProvider } from '../context/AccountContext';
import { AccountListProvider } from '../context/AccountListContext';

export const accountDetailsRoute = (
  <Route path="/account_details/:accountId/:accountName/:clientName" element={<MainLayout />}>
    <Route 
      index 
      element={
        <AccountListProvider>
          <AccountDetails />
        </AccountListProvider>
      } 
    />
  </Route>
);
